// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"271":"ff14faf5","272":"9fc3bfc4","453":"4b873f29"}[chunkId] + ".chunk.js";
};